import { Injectable, inject } from '@angular/core';
import { ApolloQueryResult } from '@apollo/client';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { GET_USER_ENTITLEMENTS, IAuthUserEntitlementsResponse } from './entitlements-api-queries';

@Injectable({
    providedIn: 'root'
})
export class EntitlementsApiService {
    private _apollo = inject(Apollo);


    public getUserEntitlements(): Observable<ApolloQueryResult<IAuthUserEntitlementsResponse>> {
        return this._apollo.use('core').query({ query: GET_USER_ENTITLEMENTS });
    }
}
